(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/components/game-loader.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/components/game-loader.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const ImageMemo = svs.tickets.next.components.ImageMemo;
const GameLoader = _ref => {
  let image = _ref.image,
    _ref$isLoadingStarted = _ref.isLoadingStarted,
    isLoadingStarted = _ref$isLoadingStarted === void 0 ? false : _ref$isLoadingStarted;
  const loaderRef = useRef(null);
  const imageData = typeof image === 'string' ? {
    src: image
  } : image;
  useEffect(() => {
    var _loaderRef$current, _loaderRef$current2;
    const launcherElement = (_loaderRef$current = loaderRef.current) === null || _loaderRef$current === void 0 ? void 0 : _loaderRef$current.closest('.default-game-launcher');
    const wrapperElement = launcherElement === null || launcherElement === void 0 ? void 0 : launcherElement.parentElement;
    const launcherWrapperElement = (_loaderRef$current2 = loaderRef.current) === null || _loaderRef$current2 === void 0 ? void 0 : _loaderRef$current2.closest('.js-game-launcher-wrapper');
    if (!launcherElement) {
      return undefined;
    }
    launcherElement.classList.add('game-loader-active');
    wrapperElement === null || wrapperElement === void 0 || wrapperElement.classList.add('game-loader-active-bg');
    launcherWrapperElement === null || launcherWrapperElement === void 0 || launcherWrapperElement.classList.add('game-loader-active-page-bg');
    return () => {
      launcherElement.classList.remove('game-loader-active');
      wrapperElement === null || wrapperElement === void 0 || wrapperElement.classList.remove('game-loader-active-bg');
      launcherWrapperElement === null || launcherWrapperElement === void 0 || launcherWrapperElement.classList.remove('game-loader-active-page-bg');
    };
  }, []);
  return React.createElement("div", {
    className: "game-loader-overlay w100 h100".concat(isLoadingStarted ? ' game-loader-overlay--loading-started' : ''),
    "data-testid": "game-loader",
    ref: loaderRef
  }, React.createElement("div", {
    className: "game-loader-bob-group"
  }, React.createElement("div", {
    className: "game-loader-skin-image w100 h100 u-flex u-flex-justify-content-center u-flex-align-items-center clip"
  }, imageData && React.createElement(ImageMemo, {
    cssSelectors: "game-loader-skin-img",
    image: imageData
  }), React.createElement("div", {
    className: "game-loader-shimmer absolute w100 h100 top-0 left-0"
  }))), React.createElement("svg", {
    "aria-hidden": "true",
    className: "game-loader-ring u-absolute",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "60",
    cy: "60",
    fill: "none",
    r: "54",
    stroke: "currentColor",
    strokeDasharray: "264 75",
    strokeLinecap: "round",
    strokeWidth: "6"
  })), React.createElement("svg", {
    className: "game-loader-logo u-absolute",
    viewBox: "-5 -8 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    className: "game-loader-circle-middle",
    cx: "32",
    cy: "14",
    r: "13"
  }), React.createElement("circle", {
    className: "game-loader-circle-left",
    cx: "10",
    cy: "35",
    r: "13"
  }), React.createElement("circle", {
    className: "game-loader-circle-right",
    cx: "54",
    cy: "35",
    r: "13"
  }), React.createElement("polygon", {
    className: "game-loader-triangle",
    points: "32,30 16,56 48,56"
  })));
};
setGlobal('svs.tickets.next.areas.play.components.GameLoader', GameLoader);

 })(window);